import useArrayState from "@clave/use-array-state";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { pushObjectToState } from "../utils/push-state";
import React from "react";
import blogApiClient from "./BlogApiClient";
import Select from "react-select";
import styles from "./BlogFeedPage.module.scss";
export const BlogFeedPage = ({ id, categories, filteredCategory, tags, filteredTags, strings, }) => {
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedTags, setSelectedTags] = useArrayState(() => []);
    const [articlesToShow, setArticlesToShow] = useArrayState(() => []);
    const activeFetch = useRef();
    const isCategorySelected = useCallback((category) => selectedCategory === category.value, [selectedCategory]);
    const selectCategory = (item) => {
        setSelectedCategory(item.value);
    };
    const unselectCategory = (item) => {
        setSelectedCategory("");
    };
    const onTagsChange = (value) => {
        setSelectedTags(value);
    };
    const filterTagsIds = useMemo(() => selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.join(","), [selectedTags]);
    const getItems = useCallback(async () => {
        var _a;
        let filterData = {
            blogId: id,
            category: selectedCategory,
            tagIds: filterTagsIds,
        };
        const abortController = new AbortController();
        (_a = activeFetch.current) === null || _a === void 0 ? void 0 : _a.abort();
        activeFetch.current = abortController;
        const result = await blogApiClient.searchArticles(filterData, abortController.signal);
        if (result && result.items)
            setArticlesToShow(result.items);
    }, [selectedCategory, selectedTags]);
    const updateQueryString = useCallback(() => {
        const objectToQuery = {};
        if ((filterTagsIds === null || filterTagsIds === void 0 ? void 0 : filterTagsIds.length) > 0) {
            objectToQuery.tagIds = filterTagsIds;
        }
        if (selectedCategory !== "")
            objectToQuery.category = selectedCategory;
        pushObjectToState(objectToQuery);
    }, [selectedCategory, selectedTags]);
    useEffect(() => {
        updateQueryString();
    }, [updateQueryString]);
    useEffect(() => {
        getItems();
    }, [getItems]);
    useEffect(() => {
        if (filteredCategory)
            setSelectedCategory(filteredCategory);
        if (filteredTags)
            setSelectedTags(filteredTags);
    }, []);
    return (React.createElement("div", { className: styles.blogContainer },
        React.createElement("section", { className: styles.blogFilterSection },
            React.createElement("div", { className: styles.blogFilterContainer },
                React.createElement("div", { className: styles.blogFilterCategories },
                    React.createElement("h3", null, strings.blog.categories),
                    categories.items.map((item) => {
                        return (React.createElement(FilterItem, { item: item, key: item.id, isSelected: isCategorySelected, select: selectCategory, unselect: unselectCategory }));
                    })),
                React.createElement("div", { className: styles.blogFilterTags },
                    React.createElement("h3", null, strings.blog.tags),
                    React.createElement(Select, { options: tags.map((tag) => ({
                            value: tag,
                            label: tag,
                        })), isMulti: true, value: selectedTags.map((tag) => ({
                            value: tag,
                            label: tag,
                        })), onChange: (value) => onTagsChange(value.map((val) => val.value)) })))),
        React.createElement("div", { className: styles.blogContent },
            React.createElement("ul", { style: { listStyle: "none", padding: "0" } }, articlesToShow.map((article) => (React.createElement("li", { key: article.id, className: styles.blogShortArticle },
                React.createElement("div", { className: styles.blogArticleThumbnail },
                    React.createElement("a", { href: article.articleUrl },
                        React.createElement("img", { src: article.imageUrl, alt: article.title, className: styles.blogShortArticleImage }))),
                React.createElement("div", { className: styles.blogArticleContent },
                    React.createElement("a", { href: article.articleUrl },
                        React.createElement("h2", { className: styles.blogShortArticleTitle }, article.title)),
                    React.createElement("p", { className: styles.blogShortArticleSummary }, article.summary),
                    article.tags.map((tag, index) => (React.createElement("a", { href: `?tagIds=${tag}` },
                        React.createElement("span", { key: index, className: styles.blogShortArticleTag }, tag))))))))))));
};
const FilterItem = ({ item, isSelected, select, unselect, }) => {
    const selected = isSelected(item);
    const toggle = useCallback(() => {
        if (selected) {
            unselect(item);
        }
        else {
            select(item);
        }
    }, [selected]);
    return (React.createElement("div", { key: item.id, className: `productListingPage-filter-category-item ${styles.blogFilterCategoryItem}` },
        React.createElement("div", { className: "checkboxWithLabel" },
            React.createElement("input", { type: "checkbox", id: item.id, value: item.id, checked: selected, onChange: toggle }),
            React.createElement("label", { className: "parent-label", htmlFor: item.id }, item.value))));
};
